import { getAuth } from 'firebase/auth';
import { db } from './firebaseConfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Analytics Service
 * Tracks user activity and page views
 */

// Log user activity to Firestore
export const logUserActivity = async (eventType, eventData = {}) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    // Get user info
    const userId = user?.uid || 'anonymous';
    const userEmail = user?.email || null;
    const isAnonymous = user?.isAnonymous || !user;

    // Get page info
    const pageUrl = window.location.pathname;
    const referrer = document.referrer || null;

    // Get device info
    const userAgent = navigator.userAgent;
    const screenSize = `${window.screen.width}x${window.screen.height}`;
    const language = navigator.language;

    // Create activity log
    const activityLog = {
      userId,
      userEmail,
      isAnonymous,
      eventType, // 'page_view', 'login', 'logout', 'action', etc.
      pageUrl,
      pageName: eventData.pageName || getPageName(pageUrl),
      referrer,
      timestamp: serverTimestamp(),
      userAgent,
      screenSize,
      language,
      ...eventData // Additional custom data
    };

    // Log to Firestore
    const logsRef = collection(db, 'userActivityLogs');
    await addDoc(logsRef, activityLog);

    // Also log to console in development
    if (process.env.NODE_ENV === 'development') {
      console.log('📊 Activity logged:', eventType, activityLog);
    }
  } catch (error) {
    console.error('Error logging user activity:', error);
    // Don't throw - analytics shouldn't break the app
  }
};

// Log page view
export const logPageView = (pageName) => {
  logUserActivity('page_view', { pageName });
};

// Log user login
export const logLogin = (method = 'email') => {
  logUserActivity('login', { method });
};

// Log user logout
export const logLogout = () => {
  logUserActivity('logout');
};

// Log custom event
export const logEvent = (eventName, eventData = {}) => {
  logUserActivity(eventName, eventData);
};

// Helper function to get page name from URL
const getPageName = (url) => {
  const pathMap = {
    '/home': 'Home',
    '/login': 'Login',
    '/register': 'Register',
    '/sessions': 'Sessions',
    '/about': 'About',
    '/contact': 'Contact',
    '/privacy': 'Privacy Policy',
    '/terms': 'Terms of Service',
    '/pricing': 'Pricing',
    '/account': 'Account',
    '/payment': 'Payment',
    '/payment/instructions': 'Payment Instructions',
    '/payment/confirmation': 'Payment Confirmation'
  };

  // Check for dynamic routes
  if (url.startsWith('/play-session/')) {
    return 'Play Session';
  }

  return pathMap[url] || 'Unknown Page';
};

export default {
  logUserActivity,
  logPageView,
  logLogin,
  logLogout,
  logEvent
};
